import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Pagination } from "antd";
import moment from "moment";

import { PhotoreqAction, SidebarCountAction } from "../../store/actions";

import useScreenSize from "../../utils/usescreensize";

import ProfileTab from "../../components/tab/profiletab";
import DashboardCard from "../../components/dashboardcard/dashboardcard";
import { PrimaryButton } from "../../components/button";
import SortDropdown from "../../components/dropdown/sortdropdown";
import Cardloader from "../../components/loader/cardloader";
import Spacer from "../../components/spacer/spacer";
import UnderHeaderMenu from "../../components/underheadermenu";

import images from "../../assets";

import "./styles.css";

const PhotoRequests = () => {
  const dispatch = useDispatch();
  const screenSize = useScreenSize();
  const [searchParams, setSearchParams] = useSearchParams();

  const validTabs = ["Pending", "Allowed"];
  const defaultTab = validTabs.includes(searchParams.get("tab"))
    ? searchParams.get("tab")
    : "Pending";
  const defaultPage = parseInt(searchParams.get("page")) || 1;

  const { photoreq, isLoading } = useSelector((state) => state.photoreq);

  const [state, setState] = useState({
    activeTab: defaultTab,
    sortOption: "desc",
  });
  const [pageNo, setPageNo] = useState(defaultPage);
  const [pageSize] = useState(8);

  useEffect(() => {
    dispatch(SidebarCountAction.updateSidebarCount({ table: "photorequest" }));
  }, []);

  useEffect(() => {
    fetchPhotoreq();
  }, [state.activeTab, state.sortOption]);

  useEffect(() => {
    setSearchParams({ tab: state.activeTab, page: pageNo.toString() });
  }, [state.activeTab, pageNo]);

  useEffect(() => {
    const tabFromURL = searchParams.get("tab") || "Pending";
    const pageFromURL = parseInt(searchParams.get("page")) || 1;

    if (tabFromURL !== state.activeTab) {
      setState((prev) => ({ ...prev, activeTab: tabFromURL }));
    }

    if (pageFromURL !== pageNo) {
      setPageNo(pageFromURL);
    }
  }, [searchParams]);

  const fetchPhotoreq = () => {
    const payload = {
      filter: state?.activeTab,
      sort: state?.sortOption,
    };
    dispatch(PhotoreqAction.getPhotoreq(payload));
  };

  const handleUpdatePhotoreq = (id, status) => {
    const payload = { senderId: id, status };

    dispatch(
      PhotoreqAction.updatePhotoreq(payload, () => {
        fetchPhotoreq();
      })
    );
  };

  const tabItems = [
    { name: "Pending", title: "Pending" },
    { name: "Allowed", title: "Allowed" },
  ];

  const sortedPhotoreq = useMemo(() => {
    if (!photoreq) return [];
    let sortedData = [...photoreq];

    if (state.sortOption === "desc") {
      sortedData.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    } else {
      sortedData.sort((a, b) => new Date(a.updatedAt) - new Date(b.updatedAt));
    }

    return sortedData;
  }, [photoreq, state.sortOption]);

  const paginatedPhotoreq = useMemo(() => {
    return sortedPhotoreq.slice((pageNo - 1) * pageSize, pageNo * pageSize);
  }, [sortedPhotoreq, pageNo, pageSize]);

  return (
    <div>
      {screenSize.width < 1023 && (
        <UnderHeaderMenu titlename="Photo Requests">
          <div style={{ width: "110px" }}>
            <SortDropdown
              data={[
                { label: "Newest First", value: "desc" },
                { label: "Oldest First", value: "asc" },
              ]}
              onChange={(e) => setState({ ...state, sortOption: e })}
              value={state?.sortOption || undefined}
              placeholder="Sort by"
            />
          </div>
        </UnderHeaderMenu>
      )}
      <Spacer height="16px" />
      <div className="photoreq-section-top-part-container">
        <div></div>
        <div className="photoreq-section-header-container">
          {screenSize.width > 1023 && (
            <h1 className="photoreq-header">Photo Requests</h1>
          )}
          <ProfileTab
            tabItems={tabItems}
            handleTab={(name) => {
              setState((prev) => ({ ...prev, activeTab: name }));
              setPageNo(1);
            }}
            activeTab={state?.activeTab}
            style={{
              background: "white",
              border: "1px solid #EAE6ED",
              width: "160px",
            }}
          />
        </div>
        {screenSize.width > 1023 && (
          <div className="photoreq-sort-container">
            <div style={{ width: "150px" }}>
              <SortDropdown
                data={[
                  { label: "Newest First", value: "desc" },
                  { label: "Oldest First", value: "asc" },
                ]}
                onChange={(e) => setState({ ...state, sortOption: e })}
                value={state?.sortOption || undefined}
                placeholder="Sort by"
              />
            </div>
          </div>
        )}
      </div>
      <Spacer height="12px" />
      <div className="photoreq-results-container">
        {isLoading ? (
          <Cardloader />
        ) : paginatedPhotoreq.length > 0 ? (
          <>
            <div className="photoreq-results">
              {paginatedPhotoreq.map((item, index) => (
                <DashboardCard
                  item={item}
                  index={index}
                  key={index}
                  redirectedfrom="photoRequests"
                >
                  <div className="flex flex-col w-full gap-3">
                    {state?.activeTab === "Pending" && (
                      <div className="photoreq-card-text">
                        <p>Pending Since:</p>
                        <p>{moment(item?.updatedAt).fromNow()}</p>
                      </div>
                    )}
                    {state?.activeTab === "Allowed" && (
                      <div className="photoreq-card-text">
                        <p>Allowed on:</p>
                        <p>{moment(item?.updatedAt).fromNow()}</p>
                      </div>
                    )}
                    {state?.activeTab === "Pending" ? (
                      <div className="interest-mobile-btn">
                        <PrimaryButton
                          style={{ background: "#F31260" }}
                          text="Deny"
                          onClick={() =>
                            handleUpdatePhotoreq(item?.username, "rejected")
                          }
                        />
                        <PrimaryButton
                          style={{ background: "#17C964" }}
                          text="Allow"
                          onClick={() =>
                            handleUpdatePhotoreq(item?.username, "accepted")
                          }
                        />
                      </div>
                    ) : (
                      <PrimaryButton
                        style={{
                          background: "#F5A524",
                          height: "32px",
                          fontSize: "14px",
                        }}
                        onClick={() =>
                          handleUpdatePhotoreq(item?.username, "rejected")
                        }
                        text="Remove Access"
                      />
                    )}
                  </div>
                </DashboardCard>
              ))}
            </div>
            <Spacer height="36px" />
            <div className="flex justify-center items-center">
              <Pagination
                pageSize={pageSize}
                total={sortedPhotoreq.length}
                current={pageNo}
                showSizeChanger={false}
                onChange={(page) => setPageNo(page)}
              />
            </div>
            <Spacer height="24px" />
          </>
        ) : (
          <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
            <img
              src={images.noActivityIcon}
              alt="no notifications"
              className="h-[160px] lg:h-full"
            />
            <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
              {state?.activeTab === "Pending"
                ? "No Photo Requests Yet"
                : "No One Has Access Yet"}
            </div>
            <p className="text-[14px] text-center max-w-[500px]">
              {state?.activeTab === "Pending"
                ? "When someone requests to view your photos, you’ll see it here."
                : "Once you allow someone to view your photos, they’ll appear here. You can manage or revoke access anytime."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhotoRequests;
